import styled from "styled-components";

export const FilterActionWrapper = styled.div`
    display: flex;
    justify-content: space-between;
    width: 100%;
`

export const FormListWrapper = styled.div`
    box-sizing: border-box;
    height: 100%;
    width: 100%;
    padding: 8px;
    .add-more {
        display: flex;
        justify-content: end;
    }
`